// Reactjs library
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
// Components
import Loading from "../Components/Common/Loading";
import { RedirectWithComponent } from "../Constants/Utils";
// Action
import { login, loginFA } from '../Store/Actions/Pages/AccessPage';
// Api Request & Response
import { LoginRequestModel } from '../Models/RequestModel/LoginRequestModel';
import { LoginResponseModel } from '../Models/ResponseModel/LoginResponseModel';
// Resource + CSS
import "../Assets/Pages/AccessPage.css";
import { LoginFreee } from "../Constants/ConstantsValue";
import Router from "../Resources/Router.json";
import { CookieAuthenModel } from '../Models/CommonModel/CookieAuthenModel';
import Screen from "../Resources/Screen.json";

function AccessPage(props) {
    // Constants value
    const cookieAuthenModel = new CookieAuthenModel();

    // Mapping state from store
    const loading = useSelector(state => state.ClientRequest.loading);
    const [loginModel, setLoginModel] = useState(null);

    // Action caller
    const dispatch = useDispatch();

    // Private state
    const [userName, setUserName] = useState(null);
    const [password, setPassword] = useState(null);
    const [isDisplayUI, setIsDisplayUI] = useState(false);

    // //#region Event

    useEffect(() => {
        let isWIAuthen = cookieAuthenModel.IsWIAuthorization();
        let isFreeeAuthen = cookieAuthenModel.IsFreeeAuthorization();

        // Display Ui login if don't login WI or Freee
        if (!isWIAuthen || !isFreeeAuthen) {
            setIsDisplayUI(true);
        }

        // Redirect main page if logged in WI and Freee
        if (isWIAuthen && isFreeeAuthen) {
            return RedirectWithComponent(Router.MainPage);
        }

        // Redirect url login Freee if don't login Freee
        if (isWIAuthen && !isFreeeAuthen) {
            freeeApiLink();
            return;
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (loginModel && loginModel.AccessKey) {
            let isFreeeAuthen = cookieAuthenModel.IsFreeeAuthorization();
            isFreeeAuthen ? RedirectWithComponent(Router.MainPage) : freeeApiLink();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loginModel]);

    const freeeApiLink = () => {
        dispatch(loginFA(LoginFreee));
    }

    const loginCallBack = (res) => {
        if (!res) return;
        setLoginModel(new LoginResponseModel(res.data));
    }

    const onLogin = (event) => {
        event.preventDefault();
        setLoginModel(null);

        let loginRequestModel = new LoginRequestModel({
            userId: userName,
            password: password
        });

        let loginAction = login(loginRequestModel, loginCallBack);
        dispatch(loginAction);
    }

    const onChangeUserName = (event) => {
        setUserName(event.target.value);
    }

    const onChangePassword = (event) => {
        setPassword(event.target.value);
    }

    //#endregion

    return <div id="access-page">
        {loading && <Loading />}
        {isDisplayUI && <div className="container">
            <div className="row">
                <br />
                <br />
            </div>
            <div className="row">
                <br />
                <br />
            </div>
            <form onSubmit={onLogin}>
                <div className={"title-main"} style={{}}>
                    <img className='logo-freee' alt="Logo freee" border="0" id="ss_img" src={'/' + process.env.REACT_APP_SUB_FOLDER + "/freee_logo_kaikei_04_color_RGB_04_XXL.png"} />
                    <label className="mainPath">{Screen.MainPage.Title}</label>
                </div>

                {(loginModel && !loginModel.AccessKey) &&
                    <div className="row">
                        <div className="col-sm-3"></div>
                        <label className="col-sm-9">{loginModel.DetailMessage}</label>
                    </div>
                }
                <div className="row">
                    <div className="col-sm-3"></div>
                    <label className="col-sm-9">{Screen.Login.TitleLogin}</label>
                </div>
                <div className="form-group row">
                    <label htmlFor="userId" className="col-sm-3 col-form-label" style={{ textAlign: "left" }}>{Screen.Login.LableUsername}</label>
                    <div className="col-sm-9">
                        <input type="text" name="userId" defaultValue={userName} onChange={onChangeUserName} maxLength="255" className="form-control" />
                    </div>
                </div>
                <div className="form-group row">
                    <label htmlFor="password" className="col-sm-3 col-form-label">{Screen.Login.LablePassword}</label>
                    <div className="col-sm-9">
                        <input type="password" name="password" defaultValue={password} onChange={onChangePassword} maxLength="32" className="form-control" />
                    </div>
                </div>
                <div className="row">
                    <br />
                </div>
                <div className="row justify-content-center">
                    <button type="submit" className="btn btn-primary mb-2">{Screen.Login.ButtonLogin}</button>
                </div>
            </form>

            <div className="row">
                <br />
            </div>
        </div>
        }
    </div>
}

export default withRouter(AccessPage);